/**
 * Created by kierangrosvenor on 25/05/2017.
 */

/**
 * Created by Kieran on 18/05/2017.
 */

import axios from 'axios'
import config from '../../config'

let ResourcesApi = {
  getMealPlans() {
    return axios.get(config.apiUrl + 'mealplans/');
  },
  getSeasonalDownloads() {
    return axios.get(config.apiUrl + 'resources/seasonal/')
  },
  getResources() {
    return axios.get(config.apiUrl + 'resources/');
  },
  saveResourceCount(model) {
    return axios.post(config.apiUrl + 'resource/download/count/', model);
  }
};

export default ResourcesApi;




// WEBPACK FOOTER //
// ./src/api/Resources/index.js